@let selectedValue = value();

<div class="rating-buttons">
  @for (option of options; track option.level) {
    <button
      type="button"
      class="rating-buttons__option"
      [class.rating-buttons__option--selected]="selectedValue === option.level"
      [rtTooltip]="option.translationKey | translate"
      (click)="select(option.level)"
    >
      <rt-icon
        [size]="'medium'"
        [name]="option.icon"
        [colorToken]="selectedValue === option.level ? option.color : 'colorIconSubduedDefault'"
      />
    </button>
  }
</div>
